module.exports = __webpack_public_path__ + "static/backend-44b4eacba674ce18553fd6b7e6a25e00.svg";